import { render, staticRenderFns } from "./kyc-chart-statistics.vue?vue&type=template&id=d1efec1c&"
import script from "./kyc-chart-statistics.vue?vue&type=script&lang=js&"
export * from "./kyc-chart-statistics.vue?vue&type=script&lang=js&"
import style0 from "./kyc-chart-statistics.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../../../tmp/ffsecurity-ui/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports